import { TERRAIN_SIGNALS_GLSL } from '../../simulation/terrain-basins';

export const BODY_MATERIAL_GLSL = `${TERRAIN_SIGNALS_GLSL}
vec3 proceduralBodyAlbedo(
  vec3 normal,
  vec4 material,
  vec4 lowColor,
  vec4 highColor,
  vec4 liquidColor,
  float algaeSignal,
  float season,
  out float liquidMask,
  out float biosphere
) {
  float surfaceClass = material.x;
  float seed = lowColor.a;
  liquidMask = 0.0;
  biosphere = 0.0;
  if (surfaceClass > 2.5) {
    float warp = fbm3D(
      normal * vec3(2.1 + seed, 5.2 + seed * 2.0, 2.1 + seed) + seed * 9.0
    );
    float broadBands = sin(
      normal.y * mix(29.0, 43.0, step(3.5, surfaceClass)) +
      warp * (3.4 + seed)
    );
    float fineBands = sin(normal.y * (67.0 + seed * 19.0) - warp * 2.1);
    float belt = broadBands * 0.43 + fineBands * 0.15 + 0.5;
    vec3 bands = mix(
      lowColor.rgb,
      highColor.rgb,
      smoothstep(0.16, 0.86, belt)
    );
    if (surfaceClass < 3.5) {
      vec3 stormCenter = normalize(vec3(
        (seed - 0.5) * 0.7,
        -0.18 - seed * 0.1,
        0.92
      ));
      float storm = 1.0 - smoothstep(
        0.07,
        0.22,
        acos(clamp(dot(normal, stormCenter), -1.0, 1.0))
      );
      bands = mix(bands, highColor.rgb * vec3(1.05, 0.46, 0.34), storm * 0.72);
    } else {
      bands = mix(bands, highColor.rgb, 0.28 + warp * 0.18);
    }
    return bands;
  }

  vec3 mapPoint =
    normal * vec3(4.2 + seed * 2.1, 3.7 + seed, 4.0 + seed * 1.4) +
    seed * 17.0;
  vec3 terrain = terrainSignals(normal, seed);
  float elevation = terrain.x;
  float fineTerrain = terrain.z;
  vec3 ground = mix(
    lowColor.rgb,
    highColor.rgb,
    smoothstep(0.27, 0.79, elevation)
  );
  float basin = smoothstep(0.68, 0.88, fbm3D(mapPoint * 1.7 + 8.0));
  ground *= 1.0 - basin * 0.24;
  liquidMask = step(0.001, material.z) *
    (1.0 - smoothstep(material.z - 0.05, material.z + 0.05, elevation));
  vec3 liquid = mix(
    liquidColor.rgb * 0.58,
    liquidColor.rgb * 1.18,
    smoothstep(0.2, 0.82, fineTerrain)
  );
  biosphere =
    smoothstep(0.07, 0.58, algaeSignal) *
    material.w *
    (1.0 - liquidMask);
  float vegetationPattern = 0.68 + fineTerrain * 0.32;
  ground = mix(
    ground,
    mix(vec3(0.025, 0.19, 0.045), vec3(0.08, 0.46, 0.1), vegetationPattern),
    biosphere * 0.92
  );
  float localSummer = season * sign(normal.y);
  float iceEdge = mix(1.0, -0.2, v_bodyClimate.y) + localSummer * 0.04;
  float polarIce = smoothstep(
    iceEdge - 0.12,
    iceEdge + 0.12,
    abs(normal.y)
  ) * clamp(v_bodyClimate.y * 4.0, 0.0, 1.0);
  vec3 surface = mix(ground, liquid, liquidMask);
  return mix(surface, v_bodyIceColour, polarIce);
}

`;
